// Entry point for the ERC AI Tuning Advisor bundle
import { createApp } from 'vue'
import AiTuningAdvisor from '@/components/AiTuningAdvisor.vue'

if (document.getElementById('erc-ai-tuning-advisor-app')) {
  createApp(AiTuningAdvisor).mount('#erc-ai-tuning-advisor-app')
}
